import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const useAppStore = create(
  persist(
    (set) => ({
      themePreference: 'system', // 'light' | 'dark' | 'system'
      nightMode: true,
      setThemePreference: (pref) => set({ themePreference: pref }),
      setNightMode: (value) => set({ nightMode: value }),
    }),
    {
      name: 'drift-app',
      partialize: (state) => ({
        themePreference: state.themePreference,
        nightMode: state.nightMode,
      }),
    }
  )
);

export default useAppStore;
